module.exports = __webpack_public_path__ + "img/04.7e691902.jpg";